<template>
  <div :class="index %2 === 0 ?'bg_s8' : 'bg_s9'">
    <div class="bc">
      <div class="up_space"/>
      <div class="row branch_area">
        <img :src="img" class="img" loading="lazy" alt/>
        <div class="img_space"/>
        <div class="row no-gutters info_area">
          <div class="text-custom-text text-left business_area">
            <div style="height:18px;"/>
            <span class="text-custom-text branchName">滿香脆脆皮豬</span>
            <span class="text-primary branchName">{{ branchName }}</span>
            <span v-if="showNickname" class="text-primary branchNickName">({{ branchNickname }})</span>
            <div style="height: 28px"/>
            <div class="row no-gutters">
              <div class="businessHours">
                <div class="text-white businessHours_text">營業時間</div>
              </div>
              <div style="width: 20px;"/>
              <div class="col">
                <span v-if="showBusiness" class="week text-custom-text">{{ businessWeekText }}</span>
                <span v-if="showBusiness" class="rest text-primary">({{ businessRestText }})</span>
                <br v-if="showBusiness"/>
                <div v-if="showBusiness" style="height: 10px;"/>
                <div v-if="showBusiness" class="time text-custom-text">{{ businessHoursText }}</div>
                <span v-if="showBusiness === false" class="rest">{{ businessNote }}</span>
              </div>
            </div>
          </div>
          <div class="divider"/>
          <div class="divider_space"/>
          <div class="address_area">

            <div style="height:  16px;"/>
            <div v-if="hasAddress === false" style="height:  30px;"/>
            <div v-if="hasAddress" class="text-left">
              <img src="/img/image/icon/location.png" class="icon" loading="lazy" alt="地址"/>
              <span class="icon_text_space"/>
              <span class="icon_text"> {{ address }}</span>
            </div>

            <div style="height:  8px;"/>
            <div v-if="hasPhone === false" style="height:  30px;"/>
            <div v-if="hasPhone" class="text-left">
              <img src="/img/image/icon/telephone.png" class="icon" loading="lazy" alt="連獲電話" />
              <span class="icon_text_space"/>
              <span class="icon_text"> {{ phone }}</span>
            </div>
            <div class="icon_space"/>
            <div class="row no-gutters third_icon_area">
              <button v-if="hasInstagram" type="button" class="btn btn_style" @click="clickUrl('instagram')">
                <img src="/img/image/icon/ig.png" class="third_icon" loading="lazy" alt="instagram"/>
              </button>
              <div v-if="hasInstagram" style="width: 20px"/>
              <button v-if="hasFacebook" type="button" class="btn btn_style" @click="clickUrl('facebook')">
                <img src="/img/image/icon/fb.png" class="third_icon" loading="lazy" alt="facebook" />
              </button>
              <div v-if="hasFacebook" style="width: 20px"/>
              <button v-if="hasPosition" type="button" class="btn btn_style" @click="clickUrl('position')">
                <img src="/img/image/icon/map.png" class="third_icon" loading="lazy" alt="position" />
              </button>
              <div v-if="hasPosition" style="width: 20px"/>
              <button v-if="hasFoodPanda" type="button" class="btn btn_style" @click="clickUrl('foodPanda')">
                <img src="/img/image/icon/foodpanda.png" class="third_icon" loading="lazy" alt="foodPanda" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="down_space"/>
    </div>
  </div>
</template>

<script>
import {getMediaUrl, isEmpty} from "../../util/helpers";

export default {
  name: "BranchInfo",
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },

  },
  computed: {
    img() {
      let val = this.item;
      return isEmpty(val) ? "" : getMediaUrl(val);
    },
    branchName() {
      let val = this.item.name;
      return isEmpty(val) ? '' : val;
    },
    showNickname() {
      return isEmpty(this.branchNickname) === false;
    },
    branchNickname() {
      let val = this.item.nickname;
      return isEmpty(val) ? '' : val;
    },
    businessWeekText() {
      let val = this.item.opening_weekdays;
      return isEmpty(val) ? '' : val;
    },
    businessRestText() {
      let val = this.item.close_weekdays;
      return isEmpty(val) ? '' : val;
    },
    businessHoursText() {
      let val = this.item.opening_hours;
      return isEmpty(val) ? '' : val;
    },
    businessNote() {
      let val = this.item.opening_note;
      return isEmpty(val) ? '' : val;
    },
    showBusiness() {
      return isEmpty(this.businessNote) === true;
    },
    address() {
      let val = this.item.address;
      return isEmpty(val) ? '' : val;
    },
    hasAddress() {
      return isEmpty(this.address) === false;
    },
    phone() {
      let val = this.item.phone_number;
      return isEmpty(val) ? '' : val;
    },
    hasPhone() {
      return isEmpty(this.phone) === false;
    },
    instagram() {
      let val = this.item.url_instagram;
      return isEmpty(val) ? '' : val;
    },
    hasInstagram() {
      return isEmpty(this.instagram) === false;
    },
    facebook() {
      let val = this.item.url_facebook;
      return isEmpty(val) ? '' : val;
    },
    hasFacebook() {
      return isEmpty(this.facebook) === false;
    },
    position() {
      let val = this.item.url_google_map;
      return isEmpty(val) ? '' : val;
    },
    hasPosition() {
      return isEmpty(this.position) === false;
    },
    foodPanda() {
      let val = this.item.url_foodpanda;
      return isEmpty(val) ? '' : val;
    },
    hasFoodPanda() {
      return isEmpty(this.foodPanda) === false;
    },
  },
  methods: {
    clickUrl(type) {
      switch (type) {
        case  "instagram":
          window.open(this.instagram, "_blank");
          break;
        case  "facebook":
          window.open(this.facebook, "_blank");
          break;
        case  "position":
          window.open(this.position, "_blank");
          break;
        case  "foodPanda":
          window.open(this.foodPanda, "_blank");
          break;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bg {

}

.bg_s8 {
  background-image: url('/img/image/background/bg_s8.png');
  background-size: contain; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: repeat; /* 防止图像重复 */
}

.bg_s9 {
  background-image: url('/img/image/background/bg_s9.png');
  background-size: contain; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  max-width: 1440px;
  text-align: center;
}


.up_space {
  height: 24px;
}

.branch_area {
  justify-content: center;
}

@media (max-width: 860px) {
  .branch_area {
    flex-direction: column;
    align-content: center;
    align-items: center;
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
}


.down_space {
  height: 24px;
}

.img {
  width: 290px;
  height: 195px;
  border-radius: 5px;
  aspect-ratio: 1.45;
}

@media (max-width: 1300px) {
  .img {
    width: 450px;
    height: 300px;
  }
}

@media (max-width: 1000px) {
  .img {
    width: 45vw;
    height: auto;
  }
}

@media (max-width: 860px) {
  .img {
    width: 420px;
  }
}

@media (max-width: 576px) {
  .img {
    width: 72vw;
  }
}

@media (max-width: 360px) {
  .img {
    width: 260px;
  }
}


.img_space {
  width: 36px;
}

.info_area {

}

@media (max-width: 1300px) {
  .info_area {
    flex-direction: column;
  }
}

@media (max-width: 860px) {
  .info_area {
    width: 420px;
  }
}

@media (max-width: 576px) {
  .info_area {
    width: 72vw;
  }
}

@media (max-width: 360px) {
  .info_area {
    width: 260px;
  }
}

.business_area {
  width: 500px;
}

@media (max-width: 1300px) {
  .business_area {
    margin-bottom: 12px;
  }
}

@media (max-width: 1000px) {
  .business_area {
    width: 40vw;
  }
}

@media (max-width: 860px) {
  .business_area {
    width: 100%;
  }
}


.branchName {
  /*font-family: Noto Sans TC;*/
  font-size: 30px;
  font-weight: 700;
  line-height: 29.69px;
  letter-spacing: 0.1em;
  text-align: left;
}

@media (max-width: 992px) {
  .branchName {
    font-size: 28px;
  }
}

@media (max-width: 576px) {
  .branchName {
    font-size: 20px;
  }
}

@media (max-width: 360px) {
  .branchName {
    font-size: 18px;
  }
}


.branchNickName {
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
}


.businessHours {
  height: 42px;
  padding: 6px;
  border-radius: 8.0px;
  background: #D56835;
}

.businessHours_text {
  font-size: 22px;
  font-weight: 400;
  //line-height: 29.69px;
  letter-spacing: 0.1em;
  text-align: left;
}

@media (max-width: 992px) {
  .businessHours_text {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .businessHours_text {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .businessHours_text {
    font-size: 16px;
  }
}

.divider {
  width: 1px;
  height: auto;
  background-color: #D56835;
  margin: 30px 0;
}

@media (max-width: 1300px) {
  .divider {
    width: auto;
    height: 1px;
    margin: 0;
  }
}


.divider_space {
  width: 45px;
}

@media (max-width: 1300px) {
  .divider_space {
    width: 0;
    height: 12px;
  }
}

.address_area {
  width: 400px;
}

@media (max-width: 1300px) {
  .address_area {
    width: 500px;
  }
}

@media (max-width: 1000px) {
  .address_area {
    width: 40vw;
  }
}

@media (max-width: 860px) {
  .address_area {
    width: 100%;
  }
}


.icon {
  width: 24px;
  height: 24px
}

@media (max-width: 768px) {
  .icon {
    width: 18px;
    height: 18px
  }
}

.icon_text_space {
  width: 16px;
}

@media (max-width: 860px) {
  .icon_text_space {
    width: 8px;
  }
}


.icon_text {
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-align: left;
  color: #D56835;
}

@media (max-width: 860px) {
  .icon_text {
    font-size: 16px;
    //white-space: nowrap;
  }
}


.icon_space {
  height: 45px;
}

@media (max-width: 1300px) {
  .icon_space {
    height: 10px;
  }
}

.third_icon_area {
  justify-content: start;
}

@media (max-width: 1300px) {
  .third_icon_area {
    justify-content: end;
  }
}

.btn_style {
  padding: 0;
  margin: 0;
  border-radius: 50%;
}

.btn_style {
  width: 45px;
  height: 45px
}

@media (max-width: 360px) {
  .btn_style {
    width: 36px;
    height: 36px
  }
}


.third_icon {
  width: 45px;
  height: 45px
}

@media (max-width: 360px) {
  .third_icon {
    width: 36px;
    height: 36px
  }
}


.week {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  line-height: 29.69px;
  text-align: left;
}

@media (max-width: 992px) {
  .week {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .week {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .week {
    font-size: 16px;
  }
}


.rest {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 500;
  line-height: 29.69px;
  text-align: left;
}

@media (max-width: 992px) {
  .rest {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .rest {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .rest {
    font-size: 16px;
  }
}


.time {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 700;
  line-height: 29.69px;
  text-align: left;
}

@media (max-width: 992px) {
  .time {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .time {
    font-size: 16px;
  }
}

@media (max-width: 360px) {
  .time {
    font-size: 16px;
  }
}


</style>
